import { render, staticRenderFns } from "./booking-event-organization-table-input.vue?vue&type=template&id=4f30478c&scoped=true&"
import script from "./booking-event-organization-table-input.vue?vue&type=script&lang=ts&"
export * from "./booking-event-organization-table-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30478c",
  null
  
)

export default component.exports